<template>
  <div class="wrapper-full nibut">
    <el-container>
      <el-main :style="`height:${dispH - 145}px;`" class="border-normal">
        <VideoPlayer
          v-if="!isHugeMapVisible"
          :record="record"
          :currentEye="currentEye"
          :butVideo="butVideo"
          :zoom="zoom"
          :src="videoSrc"
          :startTime="calcstarttime"
          :realTotalTime="totaltime"
          :usefulTime="usefultime"
          @if-OS="ifOS"
          @show-capture="showCapture"
        />
        <div v-if="isHugeMapVisible" class="wrapper-full">
          <NibutMap
            :dispW="dispW - 862"
            :dispH="dispH - 180"
            :mapData="mapData"
            :outputStyle="outputStyle"
            :usefulTime="usefultime"
          />
        </div>
      </el-main>
      <el-aside width="570px" :style="`height:${dispH - 100}px;padding-bottom:5px`">
        <div class="aside-container">
          <div style="width: 570px; height: 500px" @click="showHugeMap">
            <NibutMap
              v-if="mapVisible"
              :dispW="570"
              :dispH="474"
              :mapData="mapData"
              :usefulTime="usefultime"
            />
          </div>
          <!-- <div :style="`height:${dispH - 100 - 80 - 500 - 80}px;`">
            <TrendChart
              :dispW="550"
              :gridRight="40"
              :dispH="dispH - 100 - 80 - 500 - 96"
              :trendData="caculateTrendData"
              :trendDataAdd="caculateTrendDataAdd"
              :xRange="{ min: 0, max: 21 }"
              :yRange="{ min: 0, max: 100 }"
              :titleVisible="false"
              :title="$t('langcfg.txtButTrendChart')"
            />
          </div> -->
          <div style="width: 474px" class="content-fbut">
            <el-form label-position="left" style="margin-top: 14px; font-size: 23px">
              <el-form-item
                :label="`${$t('langcfg.txtUserPlacidoLipidlayerRecoup')}1: ${$t('langcfg.txtFirstRuptureTime')}:`"
              >
                <span class="baseFontSize">{{ VIDEOONEFIRSTRUPTURETIME }}</span>
              </el-form-item>
              <el-form-item
                v-if="butVideo"
                :label="`${$t('langcfg.txtUserPlacidoLipidlayerRecoup')}2: ${$t('langcfg.txtFirstRuptureTime')}:`"
              >
                <span class="baseFontSize">{{ VIDEOTWOFIRSTRUPTURETIME }}</span>
              </el-form-item>
              <el-form-item
                v-if="butVideo"
                :label="`${$t('langcfg.txtUserPlacidoLipidlayerRecoup')}3: ${$t('langcfg.txtFirstRuptureTime')}:`"
              >
                <span class="baseFontSize">{{ VIDEOTHREEFIRSTRUPTURETIME }}</span>
              </el-form-item>
              <el-form-item :label="$t('langcfg.txtAVGFirstRuptureTime') + ':'">
                <span class="baseFontSize">{{ OPIMEANRUPTURETIME }}s</span>
              </el-form-item>
              <!-- <el-form-item :label="$t('langcfg.txtAverageRuptureTime') + ':'">
                <span class="baseFontSize">{{ AVGRUPTRURETIME }}</span>
              </el-form-item> -->
              <el-form-item :label="`OPI${$t('langcfg.txtOPI')}` + ':'">
                <span class="baseFontSize click" @click="paramClick"
                  >{{ OPIMEANRUPTURETIME }} / {{ OPICMPLTBLKINV }}</span
                >
              </el-form-item>
              <div class="param-value" @click="paramClick">
                <el-tooltip
                  v-model="showOPI"
                  :content="'OPI = TFBUT / IBI'"
                  manual
                  placement="bottom"
                  popper-class="tip"
                >
                  <i
                    class="el-icon-warning-outline"
                    style="cursor: pointer; width: 35px; text-align: center"
                  ></i>
                </el-tooltip>
              </div>
            </el-form>
          </div>
        </div>
      </el-aside>
    </el-container>
  </div>
</template>
<script>
import { Size, SubPageSize } from "../../mixins";
import VideoPlayer from "./basic/VideoPlayer";
import TrendChart from "./basic/ButTrend";
import NibutMap from "./basic/ButMap";
import { objectCopy, getImageUrl, isDefined } from "../../shared/utils";
import butJSON from "./nibut.json";
import EVENTS from "../../bus";
export default {
  name: "But",
  mixins: [Size, SubPageSize],
  data() {
    return {
      zoom: 1.5,
      videoSrc: "",
      trendData: {
        tearArrayX: [],
        tearArrayY: []
      },
      isHugeMapVisible: false,
      mapVisible: false,
      mapData: [],
      mycurrentrecord: {},
      photos: [],
      calcstarttime: -1,
      totaltime: -2,
      usefultime: 0,
      firstrupturetime: "",
      avgRuptruretime: "",
      caculateTrendData: [],
      caculateTrendDataAdd: [],
      outputStyle: {
        asideStyle: "0",
        canvasStyle: "padding-left:80px"
      },
      lightradring: 0,
      butVideo: false,
      videoOneFirst: "",
      videoTwoFirst: "",
      videoThreeFirst: "",
      videoOneUseful: "",
      videoTwoUseful: "",
      videoThreeUseful: "",
      showOPI: false
    };
  },
  props: {
    record: {
      type: Object
    },
    currentEye: {
      type: String,
      default: "OS"
    }
  },
  watch: {
    currentEye(newType) {
      this.showOPI = false;
      this.currentEye = newType;

      this.isHugeMapVisible = false;
      this.mapVisible = false;
      this.$bus.$emit("fbutVideo");
      this.ifOS(this.record);
    },
    record: {
      handler(newRecord) {
        if (newRecord && newRecord.content) {
          this.ifOS(newRecord);
        }
      },
      deep: true
    }
  },
  mounted() {
    this.ifOS(this.record);
    // 模拟数据
    this.$bus.$on(EVENTS.showOPI, () => {
      this.showOPI = false;
    });
  },
  components: {
    VideoPlayer,
    TrendChart,
    NibutMap
  },
  methods: {
    showHugeMap() {
      this.isHugeMapVisible = !this.isHugeMapVisible;
    },
    ifOS(record, value = 0) {
      this.mycurrentrecord = objectCopy(record);
      console.log(
        "fbut ifOS",
        this.mycurrentrecord,
        this.mycurrentrecord.content[`data${this.currentEye}`]
      );
      if (this.mycurrentrecord.content[`data${this.currentEye}`].fbut) {
        const { fbut } = this.mycurrentrecord.content[`data${this.currentEye}`];
        this.butVideo = fbut.length > 1;
        const { photos } = fbut[value];
        this.photos = photos;
        const { filename } = this.photos[0];
        this.videoSrc = this.getImageURL(filename);

        const {
          rupturetimes,
          totaltime,
          calcstarttime,
          usefultime,
          firstrupturetime,
          avgruptruretime,
          lightradring,
          firsttimelight
        } = fbut[value];
        if (fbut.length > 1) {
          this.videoOneFirst = Number(fbut[0].firstrupturetime);
          this.videoTwoFirst = Number(fbut[1].firstrupturetime);
          this.videoThreeFirst = Number(fbut[2].firstrupturetime);
          this.videoOneUseful = fbut[0].usefultime
            ? Number(fbut[0].usefultime.toFixed(2))
            : Number(fbut[0].totaltime.toFixed(2));
          this.videoTwoUseful = fbut[1].usefultime
            ? Number(fbut[1].usefultime.toFixed(2))
            : Number(fbut[1].totaltime.toFixed(2));
          this.videoThreeUseful = fbut[2].usefultime
            ? Number(fbut[2].usefultime.toFixed(2))
            : Number(fbut[2].totaltime.toFixed(2));
        } else {
          this.videoOneFirst = Number(fbut[0].firstrupturetime);
          this.videoOneUseful = fbut[0].usefultime
            ? Number(fbut[0].usefultime.toFixed(2))
            : Number(fbut[0].totaltime.toFixed(2));
        }

        this.lightradring = lightradring;
        this.mapData = rupturetimes === -1 ? [] : rupturetimes;
        // this.mapData = rupturetimes
        this.trendMapData = rupturetimes;
        this.mapVisible = true;
        // toFixed()转化结果为String
        this.totaltime = isDefined(totaltime) ? Number(totaltime.toFixed(2)) : 0;
        this.calcstarttime = isDefined(calcstarttime) ? Number(calcstarttime.toFixed(2)) : 0;
        this.usefultime = isDefined(usefultime) ? Number(usefultime.toFixed(2)) : 0;
        // this.usefultime = butJSON.content.dataOD.nibut.usefultime // 获取了模拟数据
        this.firstrupturetime = firstrupturetime;
        this.avgRuptruretime = avgruptruretime;
        // 对trendData做处理
        if (rupturetimes) {
          this.handleRupturetimes(); // 红色曲线
          this.processRupturetimes(); // 蓝色曲线
        }
      }
    },
    // 拼接src
    getImageURL(filename) {
      return getImageUrl(filename, window.server, window.token);
    },
    sequence(a, b) {
      if (a > b) return 1;
      else if (a < b) return -1;
      else return 0;
    },
    // 新增 限定环数的 折线数据
    processRupturetimes() {
      let mapData = this.mapData.slice(0, 159);

      let [a, x, y, k] = [[], [], [], 0];
      a = mapData.sort(this.sequence);
      let rings = 16 * this.lightradring; // 动参多少环数
      for (let i = 0; i < rings; i++) {
        if (mapData[i] !== 0 && mapData[i] !== -1 && mapData[i] <= this.usefultime) {
          x.push(mapData[i]);
          k++;
          y.push(Math.floor((k / mapData.length) * 100));
        }
      }

      this.caculateTrendDataAdd = this.createTrendData(x, y);
    },
    // 以下为原有折线数据处理
    handleRupturetimes() {
      let mapData = this.mapData.concat();
      let [a, x, y, k] = [[], [], [], 0];
      a = mapData.sort(this.sequence);
      for (let i = 0; i < mapData.length; i++) {
        if (mapData[i] !== 0 && mapData[i] !== -1 && mapData[i] <= this.usefultime) {
          x.push(mapData[i]);
          k++;
          y.push(Math.floor((k / mapData.length) * 100));
        }
      }
      this.caculateTrendData = this.createTrendData(x, y);
    },
    createTrendData(X, Y) {
      let tearArrayYNeed = [];
      let tearArrayXNeed = [];
      let data;
      let endAxias = this.usefultime + this.calcstarttime;
      for (let i = 0; i < Y.length; i++) {
        if (Y[i] <= this.usefultime) {
          tearArrayYNeed.push(Y[i]);
        }
      }
      tearArrayXNeed = [...X, endAxias];
      tearArrayYNeed.push(tearArrayYNeed[tearArrayYNeed.length - 1]);
      data = tearArrayXNeed.map((key, value) => [key, tearArrayYNeed[value]]);
      for (let j = 0; j < data.length; j++) {
        if (data[j][1] === undefined) {
          data[j][1] = this.usefultime;
        }
      }
      return data;
    },
    showCapture() {
      this.$emit("show-capture", "fbut");
    },
    paramClick() {
      this.showOPI = !this.showOPI;
    }
  },
  computed: {
    // FIRSTRUPTURETIME () {
    //   if (this.firstrupturetime) {
    //     if (this.firstrupturetime === -1) {
    //       return '>0s'
    //     } else if (this.firstrupturetime === 10000) {
    //       return this.usefultime ? `>${this.usefultime}s` : '>21s'
    //     } else {
    //       return `${this.firstrupturetime.toFixed(2)}s`
    //     }
    //   } else if (this.firstrupturetime === 0) {
    //     // return `${this.firstrupturetime}s`
    //     return `0.04s`
    //   } else {
    //     return '--'
    //   }
    // },
    VIDEOONEFIRSTRUPTURETIME() {
      if (this.videoOneFirst) {
        if (this.videoOneFirst === -1) {
          return ">0s";
        } else if (this.videoOneFirst === 10000) {
          return this.videoOneUseful ? `>${this.videoOneUseful}s` : ">21s";
        } else {
          return `${this.videoOneFirst.toFixed(2)}s`;
        }
      } else if (this.videoOneFirst === 0) {
        // return `${this.videoOneFirst}s`
        return `0.04s`;
      } else {
        return "--";
      }
    },
    VIDEOTWOFIRSTRUPTURETIME() {
      if (this.videoTwoFirst) {
        if (this.videoTwoFirst === -1) {
          return ">0s";
        } else if (this.videoTwoFirst === 10000) {
          return this.videoTwoUseful ? `>${this.videoTwoUseful}s` : ">21s";
        } else {
          return `${this.videoTwoFirst.toFixed(2)}s`;
        }
      } else if (this.videoTwoFirst === 0) {
        // return `${this.videoTwoFirst}s`
        return `0.04s`;
      } else {
        return "--";
      }
    },
    VIDEOTHREEFIRSTRUPTURETIME() {
      if (this.videoThreeFirst) {
        if (this.videoThreeFirst === -1) {
          return ">0s";
        } else if (this.videoThreeFirst === 10000) {
          return this.videoThreeUseful ? `>${this.videoThreeUseful}s` : ">21s";
        } else {
          return `${this.videoThreeFirst.toFixed(2)}s`;
        }
      } else if (this.videoThreeFirst === 0) {
        // return `${this.videoThreeFirst}s`
        return `0.04s`;
      } else {
        return "--";
      }
    },
    OPIMEANRUPTURETIME() {
      let fbut = this.record.content[`data${this.currentEye}`].fbut;
      if (
        fbut.length === 3 &&
        (fbut[0].firstrupturetime || fbut[0].firstrupturetime == 0) &&
        (fbut[1].firstrupturetime || fbut[1].firstrupturetime == 0) &&
        (fbut[2].firstrupturetime || fbut[2].firstrupturetime == 0)
      ) {
        let num1 = fbut[0].firstrupturetime === 0 ? 0.04 : fbut[0].firstrupturetime;
        let num2 = fbut[1].firstrupturetime === 0 ? 0.04 : fbut[1].firstrupturetime;
        let num3 = fbut[2].firstrupturetime === 0 ? 0.04 : fbut[2].firstrupturetime;
        if (fbut[0].firstrupturetime === 10000) {
          num1 = fbut[0].usefultime
            ? Number(fbut[0].usefultime.toFixed(2))
            : Number(fbut[0].totaltime.toFixed(2));
        }
        if (fbut[1].firstrupturetime === 10000) {
          num2 = fbut[1].usefultime
            ? Number(fbut[1].usefultime.toFixed(2))
            : Number(fbut[1].totaltime.toFixed(2));
        }
        if (fbut[2].firstrupturetime === 10000) {
          num3 = fbut[2].usefultime
            ? Number(fbut[2].usefultime.toFixed(2))
            : Number(fbut[2].totaltime.toFixed(2));
        }
        let averagenum = (num1 + num2 + num3).toFixed(2);
        return (averagenum / 3).toFixed(2);
      } else if (fbut.length === 1 && (fbut[0].firstrupturetime || fbut[0].firstrupturetime == 0)) {
        let num = fbut[0].firstrupturetime.toFixed(2);
        if (fbut[0].firstrupturetime === 10000) {
          num = fbut[0].usefultime
            ? Number(fbut[0].usefultime.toFixed(2))
            : Number(fbut[0].totaltime.toFixed(2));
        }
        return num;
      } else {
        return "--";
      }
    },
    OPICMPLTBLKINV() {
      let blink = this.record.content[`data${this.currentEye}`].blink;
      if (blink && blink.NumTotalBlk && blink.videoTime) {
        return Number(blink.videoTime / blink.NumTotalBlk).toFixed(1);
      } else {
        return "--";
      }
    }
  },
  destroyed() {
    this.showOPI = false;
    this.$bus.$off(EVENTS.showOPI);
  }
};
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  height: 80px;
}
.border-top {
  border-top: solid rgba(gray, 0.1) 1px;
}
.nibut {
  position: relative;
}
.baseFontSize {
  font-size: 23px;
  float: right;
  line-height: 50px;
}
.switch-video {
  text-align: right;
}
/deep/ .el-form-item {
  line-height: 50px;
  height: 50px;
}
/deep/.el-form-item__label {
  margin-left: 5px;
  font-size: 23px;
  line-height: 50px;
}
/deep/.el-form-item__content {
  line-height: 65px;
  height: 65px;
  font-size: 30px;
}
/deep/ .el-radio-group {
  padding-left: 10px;
}
/deep/ .el-radio__label {
  font-size: 30px;
  vertical-align: middle;
  margin-right: 10px;
}
/deep/ .el-radio__inner {
  width: 20px;
  height: 20px;
}
.content-fbut {
  position: relative;
}
.param-value {
  position: absolute;
  right: -34px;
  bottom: 10px;
}
.click {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/dryeye/components/But.vue